import {Avatar} from '@/components/ui/avatar/Avatar'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {LogOut01Icon, MessageChatSquareIcon, User01Icon} from '@/components/ui/icon/Icon'
import {useAuthStore} from '@/features/auth/store/store'
import {useTranslation} from '@/translations/i18n'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {useMemo} from 'react'
import {Divider} from '@/components/ui/divider/Divider'
import {logout} from '@/features/auth/store/actions'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledAccountMenu, StyledMenuItem} from './style'
import {AccountModal} from '@/features/account/components/account-modal/AccountModal'
import {useAccountStore} from '@/features/account/store/useAccountStore'
import {useBugReporterStore} from '@/features/bug-reporter/store/useBugReporterStore'
import {Text} from '@/components/ui/text/Text'

export const AccountMenu = () => {
    const {t} = useTranslation()

    const user = useAuthStore(state => state.user)
    const isAccountModalOpened = useAccountStore(state => state.isAccountModalOpened)
    const setIsAccountModalOpened = useAccountStore(state => state.setIsAccountModalOpened)
    const openBugReporter = useBugReporterStore(state => state.open)

    const userFullName = useMemo(() => `${user?.firstName} ${user?.lastName}`, [user])

    if (!user) return <Skeleton height={26} width={100} />

    return (
        <>
            {isAccountModalOpened && user && <AccountModal user={user} width={'880px'} />}
            <Flexbox gap={3} align="center">
                <MenuProvider>
                    <MenuButton
                        render={
                            <Button className="print-hidden" size="sm" variant="secondary" shape="roundedRectangle">
                                <Avatar name={userFullName} imageUrl={user?.avatarUrl ?? '-'} size={'xs'} />
                                <Text size="textXs" palette="neutral" weight="500" shade="600">
                                    {userFullName}
                                </Text>
                            </Button>
                        }
                    />
                    <StyledAccountMenu gutter={8}>
                        <StyledMenuItem
                            disabled
                            render={
                                <Flexbox gap={3} align={'center'}>
                                    <Avatar name={userFullName} imageUrl={user?.avatarUrl ?? '-'} size={'sm'} />
                                    <Flexbox direction={'column'}>
                                        <Text size="textSm" palette="neutral" weight="500" shade="black">
                                            {userFullName}
                                        </Text>
                                        <Text size="textXs" palette="neutral" shade="600">
                                            {user?.email}
                                        </Text>
                                    </Flexbox>
                                </Flexbox>
                            }
                        />
                        <Divider direction={'horizontal'} width={1} />
                        <StyledMenuItem
                            render={
                                <Flexbox gap={2} align={'center'} onClick={() => setIsAccountModalOpened(true)}>
                                    <User01Icon size={15} />
                                    {t('commons:your_account')}
                                </Flexbox>
                            }
                        />
                        <Divider direction={'horizontal'} width={1} />
                        <StyledMenuItem
                            render={
                                <Flexbox gap={2} align={'center'} onClick={openBugReporter}>
                                    <MessageChatSquareIcon size={15} />
                                    Segnala un problema
                                </Flexbox>
                            }
                        />
                        <Divider direction={'horizontal'} width={1} />
                        <StyledMenuItem
                            render={
                                <Flexbox gap={2} align={'center'} onClick={logout}>
                                    <LogOut01Icon size={15} />
                                    {t('commons:logout')}
                                </Flexbox>
                            }
                        />
                    </StyledAccountMenu>
                </MenuProvider>
            </Flexbox>
        </>
    )
}
